// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-sticky path[data-v-14b9841d],.header-sticky rect[data-v-14b9841d]{fill:#fff!important}.header-sticky .still-red path[data-v-14b9841d],.header-sticky .still-red rect[data-v-14b9841d]{fill:#ff4235!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
